/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Missing_Ellipses_LabelInputs */



/**
* | output |
* | --- |
* | "Missing Ellipses" |
*
* @param {Style_Guide_Manager_Missing_Ellipses_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_missing_ellipses_label = /** @type {((inputs?: Style_Guide_Manager_Missing_Ellipses_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Missing_Ellipses_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de suspension manquants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlende Auslassungspunkte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ellissi mancanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отсутствующие эллипсы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elipses faltantes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缺失的省略号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("省略記号が欠落している")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लुप्त दीर्घवृत्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Elipses Ausentes")
	return /** @type {LocalizedString} */ ("Missing Ellipses")
});